import { Button } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import { IconLock } from "@tabler/icons-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React from "react";
import { TaskCompletedCount } from "../../../components";
import { ActionIcon, IssueIcon } from "../../../components/CustomIcons/CustomIcons";
import { useAppSelector } from "../../../hooks";
import { selectHttpIssuesOnBoard } from "./issueSelectors";
import { getTaskCompleteCount } from "./issueUtils";

export const IssueIdWithAksjonCompletedCount: React.FC<{
  issue: IIssueApi;
  setSelectedIssue: (issue: IIssueApi) => void;
  id: string;
  showClientLock?: boolean;
  useIssueBoardCache?: boolean;
}> = ({ issue, setSelectedIssue, id, showClientLock = false, useIssueBoardCache = false }) => {
  const issueFromCache = useAppSelector((state) =>
    useIssueBoardCache === true ? selectHttpIssuesOnBoard(state).find((item) => item._id === issue._id) : undefined,
  );
  const displayIssue = issueFromCache ?? issue;

  return (
    <div className="d-flex align-items-center">
      {displayIssue._id != null && <IssueIdButton issue={displayIssue} setSelectedIssue={setSelectedIssue} id={id} />}
      {showClientLock === true && (
        <IconLock color="var(--mantine-color-red-6)" size={16} style={{ flexShrink: 0, marginLeft: 4 }} />
      )}
      <div className="flex-fill" />
      <TaskCompletedCount taskCompleteCount={getTaskCompleteCount(displayIssue, true)} />
    </div>
  );
};

export const IssueIdButton: React.FC<{ issue: IIssueApi; setSelectedIssue: (issue: IIssueApi) => void; id: any }> = ({
  issue,
  setSelectedIssue,
  id,
}) => {
  return (
    <Button color="mc-primary" variant="subtle" px="xs" size="sm" onClick={() => setSelectedIssue(issue)}>
      {issue.taskOrIssue === "ISSUE" && (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <IssueIcon style={{ fontSize: ".9em", display: "block" }} />
          <b>
            <u>{id}</u>
          </b>
        </span>
      )}
      {issue.taskOrIssue === "TASK" && (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <ActionIcon style={{ fontSize: "1.1em", color: "var(--mantine-color-gray-6)", display: "block" }} />
          <span>{id}</span>
        </span>
      )}
    </Button>
  );
};
